import React from "react";
import { getImageUrl } from "../../../../api/leads";
import { Link } from "react-router-dom";
import gridImg1 from "../../../../assets/image/grid-img-1.jpg";
import gridImg2 from "../../../../assets/image/grid-img-2.jpg";
import gridImg3 from "../../../../assets/image/grid-img-3.jpg";
import gridImg4 from "../../../assets/image/grid-img-4.jpg";
import gridImg5 from "../../../../assets/image/grid-img-5.jpeg";
export default function BottomStory({ bottomStory }: any) {
  const paragraph = bottomStory.map((item) => item.section.length);

  return (
    <>
      <section className="grid-images-container">
        <div className="container">
          <div className="row">
            <div className="col-md-12 grid-img-1 img-container">
              <Link replace
                to={`/local/${bottomStory[3].localstories.storyname}`}
                className="read-more-link"
              >
                <img
                  className="grid-img img-fluid"
                  src={getImageUrl(
                    bottomStory[3].localstories.foldername,
                    bottomStory[3].photo[0].photo
                  )}
                  alt={bottomStory[3].localstories.subtitle}
                />
                <div className="grid-img-text">
                  {bottomStory[3].localstories.subtitle}
                  <span className="read-more-link">READ MORE</span>
                </div>
              </Link>
            </div>
            <div className="second-row-img">
              <div className="flex-container">
                <div className=" grid-img-2 img-container">
                  <Link replace
                    to={`/local/${bottomStory[12].localstories.storyname}`}
                    className="read-more-link"
                  >
                    <img
                      className="grid-img img-fluid"
                      src={getImageUrl(
                        bottomStory[12].localstories.foldername,
                        bottomStory[12].photo[0].photo
                      )}
                      alt={bottomStory[12].localstories.subtitle}
                    />
                    <h6 className="img-content">
                      {bottomStory[12].localstories.subtitle}{" "}
                      <span className="read-more-link">READ MORE</span>
                    </h6>
                  </Link>
                </div>

                <div className="grid-img-3 img-container">
                  <Link replace
                    to={`/local/${bottomStory[2].localstories.storyname}`}
                    className="read-more-link"
                  >
                    <img
                      className="grid-img img-fluid"
                      src={getImageUrl(
                        bottomStory[2].localstories.foldername,
                        bottomStory[2].photo[3].photo
                      )}
                      alt={bottomStory[2].localstories.subtitle}
                    />
                    <h6 className="img-content">
                      {bottomStory[2].localstories.subtitle}{" "}
                      <span className="read-more-link">READ MORE</span>
                    </h6>
                  </Link>
                </div>
              </div>
              <div className=" grid-img-4 img-container">
                <Link replace
                  to={`/local/${bottomStory[9].localstories.storyname}`}
                  className="read-more-link"
                >
                  <img
                    className="grid-img img-fluid"
                    src={getImageUrl(
                      bottomStory[9].localstories.foldername,
                      bottomStory[9].photo[0].photo
                    )}
                    alt={bottomStory[9].localstories.title}
                  />
                  <h6 className="img-content">
                    {bottomStory[9].localstories.title}
                    <span className="read-more-link">READ MORE</span>
                  </h6>
                </Link>
              </div>
            </div>
            <div className="third-row-content">
              <div className="content-wrap">
                <div className="text-content">
                  "I just love this magazine so much! I get so excited when I
                  get it. I literally dread when I get to the last page, so I
                  take my time and read every word on every page!"
                </div>
                <div className="name-content">- Lois A</div>
                <div className="text-content">
                  "The entire publication is a true work of art."
                </div>
                <div className="name-content">- Ryan D</div>
                <div className="text-content">
                  "What a breath of fresh air! The attention to detail is
                  incredible, the photography is artistic, and the way you
                  introduce businesses to readers is so relevant and engaging."
                </div>
                <div className="name-content">- Nora Z</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
